import BaseFormHelperText from '@material-ui/core/FormHelperText'

const FormHelperText = BaseFormHelperText

export default FormHelperText
